export default __webpack_public_path__ + "static/media/product-mobile.1489214b.jpg";